export interface IMddleData {
  noData: boolean;
  deleteArr: any[];
  canDelete: boolean;
  chooseIndex: string;
}

export const middleStatus: IMddleData = {
  noData: false,
  chooseIndex: "",
  deleteArr: [],
  canDelete: true,
};
